
import { defineComponent, inject } from 'vue';
import { Modal } from 'ant-design-vue';
import {
  CloudServerOutlined,
  VerticalAlignTopOutlined,
  CloseOutlined,
  ImportOutlined
} from '@ant-design/icons-vue';
import { Message } from '@/appConfig';
import { setTop, cancelTop } from '@/services/home';
import HomeStatus from '@/components/HomeStatus.vue';
import { isCustom } from '@/components/customConditionList';

export default defineComponent({
  name: 'HomeProject',
  components: {
    CloudServerOutlined,
    VerticalAlignTopOutlined,
    CloseOutlined,
    ImportOutlined,
    HomeStatus
  },
  props: {
    project: Object
  },
  emits: ['go-custom', 'refresh'],
  setup(props, ctx) {
    const message = inject('$message') as Message;
    interface Props {
      project: {
        projectVo: object;
        top: boolean;
      };
    }
    const propObj = (props as unknown) as Props;
    const projectData = propObj.project;

    function setProjectTop(projectId: number) {
      setTop(projectId)
        .then(res => {
          if (res.data && res.data.success) {
            projectData.top = true;
            ctx.emit('refresh');
            message.success('置顶成功！');
          } else {
            const msg =
              res.data && res.data.msg ? res.data.msg : '获取项目列表失败！';
            message.error(msg);
          }
        })
        .catch(res => {
          const msg =
            res.data && res.data.msg ? res.data.msg : '获取项目列表失败！';
          message.error(msg);
        });
    }

    function cancelProjectTop(projectId: number) {
      cancelTop(projectId)
        .then(res => {
          if (res.data && res.data.success) {
            projectData.top = false;
            ctx.emit('refresh');
            message.success('取消置顶成功！');
          } else {
            const msg =
              res.data && res.data.msg ? res.data.msg : '获取项目列表失败！';
            message.error(msg);
          }
        })
        .catch(res => {
          const msg =
            res.data && res.data.msg ? res.data.msg : '获取项目列表失败！';
          message.error(msg);
        });
    }

    function goProject(
      project: { id: number; projectStatus: string },
      userProjectRel: { roleId: number; userStatus: string }
    ) {
      console.log('click');
      if (
        userProjectRel.userStatus === 'FROZEN' ||
        project.projectStatus !== 'IN_PROGRESS'
      ) {
        console.log('冻结，非进行中');
        return;
      }
      if (userProjectRel.roleId === 0) {
        Modal.warning({
          title: '暂无当前项目权限',
          content: '请联系管理员配置权限',
          okText: '确定',
          centered: true,
          maskClosable: true,
          width: 438
        });
      } else {
        if (isCustom(project.id)) {
          ctx.emit('go-custom', project.id);
        } else {
          location.href = `/keyan/?projectId=${project.id}`;
        }
      }
    }

    return {
      projectData,
      setProjectTop,
      cancelProjectTop,
      goProject
    };
  }
});
